import * as React from 'react';
import { Typography, Box, Container, TextField, CssBaseline, Button, Avatar, Select, MenuItem, FormHelperText, InputLabel, CircularProgress, FormControl, Tabs, Tab, Card, CardHeader, CardMedia, IconButton } from '@mui/material';
import { connect } from "react-redux";
import { Navigate, NavLink, Route, Routes, useNavigate, useParams } from "react-router-dom";
import { centered_flex_box, MainInput, MainInputLabel, MainPassword, main_button, StyledInput, MainPhone, sec_button } from '../../app/components/Styles';
import { isMobile } from 'react-device-detect';
import Cookies from 'js-cookie';
import { useTranslation } from 'react-i18next';
import { addEmployees, getWarehouses } from '../../app/store/actions/imsWarehouseStaffActions';
import { useEffect } from 'react';

export const CreateEmployee = ({ addEmployees, getWarehouses, warehouses, user, isLoading }) => {

    const navigate = useNavigate();
    const [warehouseId, setWarehouseId] = React.useState(null);


    const handleSubmit = async (event) => {
        event.preventDefault();
        const data = new FormData(event.currentTarget);

        var order = {
            name: data.get('name'),
            email: data.get('email'),
            password: data.get('password'),
            warehouseId: data.get('warehouseId'),
        }
        addEmployees(order, navigate);
    };

    useEffect(() => {
        getWarehouses({ page: 1, limit: 100 })
    }, [])

    if (isLoading) {
        return (
            <Container maxWidth="xs">
                <Box sx={{ ...centered_flex_box, minHeight: isMobile ? "100%" : "100vh", minWidth: "100%" }}>
                    <CircularProgress sx={{ color: "var(--secColor)" }} />
                </Box>
            </Container>
        )
    }

    return (
        <Container maxWidth="xs">
            <Box
                sx={{
                    paddingTop: 3,
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center'
                }}
            >
                <Box sx={{ width: '100%', mt: 2 }}>
                    <Typography mt={2} variant='h4' textAlign={"center"} sx={{ color: "var(--secColor)" }}>Create Picker & Packer</Typography>
                    <Box component="form" onSubmit={handleSubmit} sx={{ mt: 1 }}>
                        <MainInput
                            margin="normal"
                            required
                            fullWidth
                            id="name"
                            label="Employee Name"
                            name="name"
                            autoFocus
                        />
                        <MainInput
                            margin="normal"
                            required
                            fullWidth
                            id="email"
                            label="Employee Email / Username"
                            name="email"
                            autoFocus
                        />
                        <MainPassword
                            margin="normal"
                            required
                            fullWidth
                            name="password"
                            label="Password"
                            type="password"
                            id="password"
                        />
                        <MainInput
                            margin="normal"
                            fullWidth
                            required
                            id="warehouseId"
                            label="Warehouse"
                            name="warehouseId"
                            autoFocus
                            select
                            defaultValue={warehouseId}
                            onChange={({ target }) => { setWarehouseId(target.value) }}
                        >
                            {warehouses?.map((warehouse) => {
                                return <MenuItem value={warehouse._id}>{warehouse.name}</MenuItem>
                            })}
                        </MainInput>
                        <Button
                            type="submit"
                            fullWidth
                            variant="contained"
                            sx={{ mt: 3, mb: 2, ...main_button }}
                        >
                            Create Picker & Packer
                        </Button>
                    </Box>
                </Box>
            </Box >
        </Container >
    );
}

const mapStateToProps = (state) => ({
    user: state?.auth?.user,
    isLoading: state?.records?.isLoading || state?.wait?.isLoading,
    warehouses: state?.records?.warehouses?.docs,
});

const mapDispatchToProps = { getWarehouses, addEmployees };

export default connect(mapStateToProps, mapDispatchToProps)(CreateEmployee);